import { parseRawItem } from './useLocalStorage'

const storagePrefix = 'e_approval_'

const readItem = (name) => {
  try {
    return parseRawItem(window.localStorage.getItem(`${storagePrefix}${name}`), null)
  } catch (error) {
    console.warn(`Unable to read "${storagePrefix}${name}" from localStorage`, error)
    return null
  }
}

const writeItem = (name, value) => {
  try {
    window.localStorage.setItem(`${storagePrefix}${name}`, JSON.stringify(value))
  } catch (error) {
    console.warn(`Unable to write "${storagePrefix}${name}" to localStorage`, error)
  }
}

const storage = {
  getUser: () => readItem('user'),
  setUser: (user) => writeItem('user', user),
  getToken: () => readItem('token'),
  setToken: (token) => writeItem('token', token),
  getRedirect: () => readItem('redirect'),
  setRedirect: (redirectObject) => writeItem('redirect', redirectObject),
  getLanguage: () => {
    try {
      return window.localStorage.getItem(`${storagePrefix}language`)
    } catch (error) {
      console.warn(`Unable to read "${storagePrefix}language" from localStorage`, error)
      return null
    }
  },
  setLanguage: (language) => {
    try {
      window.localStorage.setItem(`${storagePrefix}language`, language)
    } catch (error) {
      console.warn(`Unable to write "${storagePrefix}language" to localStorage`, error)
    }
  },
  clear: () => {
    try {
      window.localStorage.removeItem(`${storagePrefix}user`)
      window.localStorage.removeItem(`${storagePrefix}token`)
    } catch (error) {
      console.warn('Unable to clear auth storage', error)
    }
  },
}

export default storage
